export default {
  NO_ACTION: null,
  RELOAD_WF: 1,
  RELOAD_ALL: 2,
  RELOAD_KOFI: 3,
};
